export const CountryLanguageServiceMocks = {};
